import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap"
import { Formik } from "formik"
import * as Yup from "yup"
import { Vendor } from "../types"

interface AdjustCommissionProps {
  isOpen: boolean
  toggle: () => void
  vendor: Vendor
}

const AdjustCommission: React.FC<AdjustCommissionProps> = ({ isOpen, toggle, vendor }) => {
  const validationSchema = Yup.object({
    commissionRateBundle: Yup.number()
      .min(0, "Must be positive")
      .max(100, "Cannot exceed 100%")
      .required("Required"),
    commissionRateOneTime: Yup.number()
      .min(0, "Must be positive")
      .max(100, "Cannot exceed 100%")
      .required("Required"),
  })

  const initialValues = {
    commissionRateBundle: "",
    commissionRateOneTime: "",
    notes: ""
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Adjust Commission - {vendor.name}
      </ModalHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Adjust commission:", values, "for vendor:", vendor.id)
          // TODO: Submit to API
          toggle()
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <div className="mb-3 p-3 bg-light rounded">
                <Row>
                  <Col xs="6">
                    <p className="text-muted mb-1 font-size-12">Vendor ID</p>
                    <p className="mb-0 fw-medium">{vendor.id}</p>
                  </Col>
                  <Col xs="6">
                    <p className="text-muted mb-1 font-size-12">Current Revenue Share</p>
                    <p className="mb-0 fw-medium">{vendor.revenueShare}</p>
                  </Col>
                </Row>
              </div>

              <FormGroup>
                <Label>
                  Commission Rate Bundle (%)
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  name="commissionRateBundle"
                  type="number"
                  placeholder="Enter bundle commission rate"
                  value={values.commissionRateBundle}
                  onChange={handleChange}
                  invalid={touched.commissionRateBundle && !!errors.commissionRateBundle}
                />
                {touched.commissionRateBundle && errors.commissionRateBundle && (
                  <div className="invalid-feedback d-block">{errors.commissionRateBundle}</div>
                )}
                <small className="text-muted">
                  Commission percentage for bundle products
                </small>
              </FormGroup>

              <FormGroup>
                <Label>
                  Commission Rate One Time Product (%)
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  name="commissionRateOneTime"
                  type="number"
                  placeholder="Enter one-time product commission rate"
                  value={values.commissionRateOneTime}
                  onChange={handleChange}
                  invalid={touched.commissionRateOneTime && !!errors.commissionRateOneTime}
                />
                {touched.commissionRateOneTime && errors.commissionRateOneTime && (
                  <div className="invalid-feedback d-block">{errors.commissionRateOneTime}</div>
                )}
                <small className="text-muted">
                  Commission percentage for one-time purchase products
                </small>
              </FormGroup>

              <FormGroup>
                <Label>Additional Notes</Label>
                <Input
                  type="textarea"
                  name="notes"
                  rows={3}
                  placeholder="Any additional information about this commission adjustment..."
                  value={values.notes}
                  onChange={handleChange}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button type="submit" className="bg-gradiant-blue border-0">
                Save Changes
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default AdjustCommission
